import { stateName } from './constants';

const localState = state => state[stateName];

export const getRequestState = state => localState(state).requestState;
export const getSystemConfiguration = state => localState(state).systemConfiguration;
export const getStripeApiKey = state => {
  var _getSystemConfigurati;

  return (_getSystemConfigurati = getSystemConfiguration(state)) === null || _getSystemConfigurati === void 0 ? void 0 : _getSystemConfigurati.stripeApiKey;
};
export const getPaymentsConfiguration = state => {
  var _getSystemConfigurati2;

  return (_getSystemConfigurati2 = getSystemConfiguration(state)) === null || _getSystemConfigurati2 === void 0 ? void 0 : _getSystemConfigurati2.payments;
};
export const getEscrowProvider = state => {
  var _getPaymentsConfigura;

  return (_getPaymentsConfigura = getPaymentsConfiguration(state)) === null || _getPaymentsConfigura === void 0 ? void 0 : _getPaymentsConfigura.escrowProvider;
};
export const getPhoneNumberPrefix = state => {
  var _getSystemConfigurati3;

  return (_getSystemConfigurati3 = getSystemConfiguration(state)) === null || _getSystemConfigurati3 === void 0 ? void 0 : _getSystemConfigurati3.phoneNumberPrefix;
};
export const getMeasurements = state => {
  var _getSystemConfigurati4;

  return (_getSystemConfigurati4 = getSystemConfiguration(state)) === null || _getSystemConfigurati4 === void 0 ? void 0 : _getSystemConfigurati4.measurements;
};
export const getPortal = state => {
  var _getSystemConfigurati5;

  return (_getSystemConfigurati5 = getSystemConfiguration(state)) === null || _getSystemConfigurati5 === void 0 ? void 0 : _getSystemConfigurati5.portal;
};
export const getBundleDiscountsConfiguration = state => {
  var _getSystemConfigurati6;

  return (_getSystemConfigurati6 = getSystemConfiguration(state)) === null || _getSystemConfigurati6 === void 0 ? void 0 : _getSystemConfigurati6.bundleDiscountsConfiguration;
};
export const getBrazeConfig = state => {
  var _getSystemConfigurati7;

  return (_getSystemConfigurati7 = getSystemConfiguration(state)) === null || _getSystemConfigurati7 === void 0 ? void 0 : _getSystemConfigurati7.crm.brazeConfig;
};